import CookieHelper from "../../helper/cookie";
import Logger from "../logger";
import meta from '../../helper/meta';
import ModelContainer from "@core/scripts/components/model-container";

export default {
    getSessionId,
    getSubSessionId,
    getUserId,
    getPageViewId,
    generateUUID,
    getTenantId,
    getDid
};

function getSubSessionId() {
    return CookieHelper.get('subWkorbId') || "";
}

function getUserId() {
    return meta.value('userId');
}

function getSessionId() {
    const wkorbId = meta.value('wkorbId');
    if (!wkorbId) {
        Logger.error(`[LANDMARK] No valid SessionId stored in meta value "wkorbId"!`, new Error('Cookie parse Error'));
        return "";
    }
    return wkorbId;
}

function getPageViewId() {
    let pageViewId = ModelContainer.get("pageViewId");
    const platformAttributesContainer = document.querySelector('[jsh-platform-attributes]');
    if (platformAttributesContainer) {
        if (platformAttributesContainer.pageViewId) {
            pageViewId = platformAttributesContainer.pageViewId;
        }
    }
    return pageViewId;
}

function getTenantId(){
    return meta.value('companyId') || ""
}

function generateUUID(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

function getDid() {
    return CookieHelper.get('did') || "";
}
